import $ from 'jquery';

export default function() {
    function init() {
        const openButton = document.querySelector('.js-additional-open');
        if (openButton) {
        openButton.addEventListener('click', (e) => {
            e.preventDefault();
            $(openButton).parent().siblings('.additionalSection').slideToggle();
            if(openButton.classList.contains('is-active')) {
                openButton.classList.remove('is-active');
                openButton.querySelector('.js-text-changer').textContent = "Show More";
            } else {
                openButton.classList.add('is-active');
                openButton.querySelector('.js-text-changer').textContent = "Show Less";
            }
        });
        }
    }

    if(document.querySelector('.person_detailed_page') || 
        document.querySelector('.js-additional-open')) {
        init();
    }
}